import { EXTERNAL_LINKS } from './publicUrlConstants'

export const EXTERNAL_URLS = {
  reverseGeocode: EXTERNAL_LINKS.reverseGeocode,
} as const
